import React, { useState, useRef, useEffect } from 'react'
import Maybe from 'components/__new/common/Maybe';
import useLoginInfo from 'hooks/useLoginInfo';
import { useSelector, useDispatch } from 'react-redux';
import { ButtonLoader, Input, SelectInput } from 'components/__new/common/form';
import { ReactComponent as IconCheckCircle } from "assets/images/icons/project-icons/check-circle-green-bg.svg"
import { electricityPurchaseValidation } from 'store/entities/billPayment/action';
import FormDrawer from 'components/__new/common/form-drawer';
import SearchableBillPaymentProviders from 'components/__new/billPayment/Providers';
import { REGEX_VALUES } from 'utils/regexValues';


const CreateElectricityBeneficiary = ({ isOpen, toggleCreateBeneficiary, initiateBeneficiaryCreation }) => {
    const dispatch = useDispatch()
    const {userInfo} = useLoginInfo();
    const searchableBillPaymentProvidersRef = useRef();
    
    const { electricityValidationLoading: isValidating, electricityValidation: validatedData, createBeneficiaryLoading } = useSelector((s) => s.entities.billPayment);    
    const [validatedMeter, setValidatedMeter] = useState(null);

    const [form, setForm] = useState({
        alias: "",
        network: {},
        amount: "",
        accountType: "",
        account: "",
        name: "",
        address: "",
        phone: "",
    });
    

    const create = (e) => {
        e.preventDefault();
        
        const params = {
                meterNumber: form.account,
                service: 'electricity',
                product: form.network?.value,
                meterType: form.accountType,
                alias: form.alias || '-',
                businessId: userInfo?.employer?._id,
            }
            
            initiateBeneficiaryCreation(params);
            // dispatch(electricityValidationReset());
            
    }
    
    // const lengthValidation = form?.account?.length === 11 || form?.account?.length === 13
    // const lengthValidation = form?.account?.length <= 13
    
    const handleNameChange = (e) => {
        const { name, value } = e.target;
        if ((name === "alias") && (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AMPERSAND_AND_HYPHEN_ONLY.test(value) || value.length > 50)) {
          return;
        }
        setForm({...form, [name]: value})
      }
    
    const handleAccountChange = (e) => {
        const { value } = e.target;
        if ((value.length !== 12) && (value >= 0)) {
            setForm({...form, account: value})
        }
    }
    
    useEffect(() => {
        if(form?.account?.length === 11 && form?.accountType?.length && form?.network?.value?.length) {
            const params = {
                account: form.account,
                accountType: form.accountType,
                service: form.network?.value,
                businessId: userInfo.employer._id,
            }
            
            dispatch(electricityPurchaseValidation(params));
        }
        // eslint-disable-next-line
    }, [form?.account, form?.accountType, form?.network])
    
    useEffect(() => {
        if(validatedData?.status === 'success') {
            setValidatedMeter(validatedData?.response);
            setForm({
                ...form,
                name: validatedData?.response?.name,
                address: validatedData?.response?.address
            })
            
        }
        // eslint-disable-next-line
    }, [validatedData])
    
    useEffect(() => {
        setForm({})
        setValidatedMeter(null);
    }, [isOpen])
    
    
    const disableSubmit = !form?.network?.label?.length || form?.account?.length !== 11 || !validatedMeter
    
    return (
        <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={() => {}}>
            <div className='w-full p-6'>
                
                <FormDrawer.Title
                    close={toggleCreateBeneficiary}
                    showCloseButton={true}
                    title="Add Single Beneficiary"
                    description="Create and add new beneficiaries to your list"
                />
                
                <form onSubmit={create}>
                    <div className="w-full mt-5">
                        
                        <Input
                                type="text"
                                label="Beneficiary Name"
                                value={form?.alias}
                                name="alias"
                                className="form-input"
                                placeholder="Enter name"
                                onChange={handleNameChange}
                            />
                        
                        <div className="relative">
                            <SearchableBillPaymentProviders
                                type="electricity"
                                label="Biller"
                                tag="products"
                                ref={searchableBillPaymentProvidersRef}
                                onValueChange={(e) => {
                                    setForm({...form, network: e, amount: "", account: ""});
                                    setValidatedMeter(null);
                                }}
                            />
                        </div>
                        
                        <div className="mt-6">
                            <SelectInput label="Meter Type" value={form.accountType} onChange={(e) => {setForm({...form, accountType: e.target.value})}}>
                                <option value="">Select</option>
                                <option value="prepaid">Prepaid</option>
                                <option value="postpaid">Postpaid</option>
                            </SelectInput>
                        </div>
                        
                        <div className='form-group relative'>
                            <label>Meter Number</label>
                            <input
                                type="number"
                                id="prl-input"
                                className="form-input"
                                value={form.account}
                                placeholder="Enter Meter Number"
                                onChange={handleAccountChange}
                            />
                            
                            <Maybe condition={validatedMeter !== null}>
                                <div className="w-full flex items-center justify-start absolute -bottom-7">
                                    <div className="flex items-center text-sm">
                                        <IconCheckCircle width={15} />
                                        <div className='ml-1.5 text-[#153344] capitalize text-xs'>{validatedMeter?.name?.toLowerCase()}</div>
                                    </div>
                                </div>
                            </Maybe>
                        </div>
                        
                        <div className='my-10' />
                    </div>
                    
                    <div className="border-t w-full flex items-center justify-end mt-4 pt-3">
                        <button type="button" onClick={toggleCreateBeneficiary} className="btn btn-transparent-primary mr-3">
                            Cancel
                        </button>
                        
                        <ButtonLoader loading={createBeneficiaryLoading} type="submit" disabled={disableSubmit} className="btn btn-ep-primary">
                            {isValidating ? "Validating..." : "Add Beneficiary"}
                        </ButtonLoader>
                    </div>
                </form>
            </div>
        </FormDrawer>
    )
}


export default CreateElectricityBeneficiary